module.exports = __webpack_public_path__ + "img/primary_8x2_z18.113346d6.svg";